<main class="main">
    <bx-header *ngIf="showHeader" #appHeader [showBuilderInfo]="showBuilderInfo"></bx-header>
    <div class="w-100 page-body" >
        <router-outlet></router-outlet>
    </div>
    <bx-footer #appFooter *ngIf="showFooter"></bx-footer>
</main>